<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="md:col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 text-gray-500 border-t border-b border-gray-300">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="form-input append"
            />
          </div>
        </template>
      </DatePicker>
      

      <filter-dropdown button-class="" button-text="More Filters" :hide-buttons="true">
        <fieldset class="form-group">
          <label class="form-label">Automation</label>
          <automation-select v-model="filter.automationId" />
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">Vehicle</label>
          <vehicle-select v-model="filter.vehicleId" />
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">Driver</label>
          <driver-select v-model="filter.driverId" />
        </fieldset>
      </filter-dropdown>
    </div>

    <div>
      <div v-if="report">
        <!-- No Results -->
        <div v-if="report.rows.length === 0" class="p-8 m-6 text-center text-gray-500 rounded-b-lg bg-gray-50">
          No results. Try broadening your query parameters.
        </div>
        <!-- Results -->
        <div class="card" v-else>
          <div class="flex flex-col justify-between p-4 border-b md:flex-row lg:p-5">
            <button class="ml-auto btn btn-sm btn-outline" @click="$parent.downloadReport()" v-submitting="$parent.submitting">
              <fa :icon="['far', 'arrow-to-bottom']" class="mr-2" /> Download
            </button>
          </div>
          <data-table
            small
            :items="report.rows" 
            :keys="[
              { name: 'Time', slug: 'time' },
              { name: 'Type', slug: 'type', display: (val) => { return automationTypes[val].name } },
              { name: 'Vehicle', slug: 'vehicle' },
              { name: 'Driver', slug: 'driver' },
              { name: 'Message', slug: 'message' },
              { name: 'Acknowledged', slug: 'acknowledged' },
              { name: 'Note', slug: 'note' }
            ]" />
          <Pagination :total="report.meta.total" :per-page="report.meta.per_page" :current-page="report.meta.current_page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sub } from 'date-fns'
import { mapState } from 'vuex'
import AutomationSelect from '@/components/AutomationSelect'
import DriverSelect from '@/components/DriverSelect'
import VehicleSelect from '@/components/VehicleSelect'
import FilterDropdown from '@/components/FilterDropdown'

export default {
  name: 'AutomationDigest',

  components: {
    AutomationSelect,
    DriverSelect,
    VehicleSelect,
    FilterDropdown
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    ...mapState(['automationTypes']),
    
    params () {
      return { 
        filter: this.filter
      }
    }
  },
  
  data () {
    return {
      filter: {
        automationId: null,
        driverId: null,
        vehicleId: null,
        timeToAcknowledgement: 0,
        date: {
          start: sub(new Date(), { days: 1 }),
          end: new Date()
        }
      }
    }
  }
}
</script>